import { PaletteColor } from "@mui/material/styles/createPalette";
import palette from '../theme/palette';

const styleOverrides = {
  root: {
    '& .MuiTreeItem-iconContainer svg': {
      fontSize: '36px !important',
      color: (palette.primary as PaletteColor).main,
    },
  },
};

export default styleOverrides;
